import * as types from './types';

/** @type {import('../../store/store').JobsState} */
let initialState = {
    cpJobs: [],
    cloudJobIds: [],
    hfwfs: [],
    jobDetails: {
        details: {
            images: [],
            jobControlStrip: undefined,
        },
        isFetching: false,
    },
    uploadInfo: {},
    imageDetails: [],
    fileUrl: '',
    certificateData: {},
    channelValuesFromState: [],
    isFetchingColorChannelMapping: false,
    graphQLErrors: null,
    isFetching: false,
    jobCookies: {},
    actions: [],
    errorColorChannelMapping: null,
};

export default function jobs(state = initialState, action) {
    switch (action.type) {
        case types.GET_CUSTOMER_CP_JOBS_SUCCESS:
            return {
                ...state,
                cpJobs: action.res.data.listCustomerCpJobs.items,
            };
        case types.GET_CP_CERTIFICATE_SUCCESS:
            return Object.assign({}, state, {
                certificateData: action.res,
            });
        case types.SUBSCRIBE_TO_CP_JOB_ADD_SUCCESS:
            // Check if job already exists to prevent duplicates
            const isJobExists = state.cpJobs.some(
                (existingJob) => existingJob.id === action.data.id && existingJob.cpId === action.data.cpId,
            );

            if (isJobExists) {
                // Job already exists, don't add duplicate
                return state;
            }

            // Add job to the list only if it doesn't exist
            const updatedCpJobs = [...state.cpJobs, action.data];
            return {
                ...state,
                cpJobs: updatedCpJobs,
            };
        case types.SUBSCRIBE_TO_CP_JOB_DELETE_SUCCESS:
            // delete job from the list , it must be existed in the list before
            const filteredCpjobsAfterDelete = state.cpJobs.filter(
                (job) => !(job.id === action.data.id && job.cpId === action.data.cpId),
            );
            return {
                ...state,
                cpJobs: filteredCpjobsAfterDelete,
            };
        case types.SUBSCRIBE_TO_CP_JOB_UPDATE_SUCCESS:
            // Check if job already exists
            const jobExists = state.cpJobs.some(
                (existingJob) => existingJob.id === action.data.id && existingJob.cpId === action.data.cpId,
            );

            // If job doesn't exist, add it to the list
            // Otherwise, update the existing job
            // Normally, we get a onCpAddJob event before getting onCpUpdateJob event,
            // but we want to make sure the job is added to the list if we missed the add event for some reason.
            const updatedCpJobsAfterUpdate = jobExists
                ? state.cpJobs.map((j) => {
                    const isJobMatch = j.id === action.data.id && j.cpId === action.data.cpId;
                    return isJobMatch
                        ? {
                            ...j,
                            name: action.data.name,
                            state: action.data.state,
                            userAction: action.data.userAction,
                            userActionMessage: action.data.userActionMessage,
                            copies: action.data.copies,
                            created: action.data.created,
                            cpId: action.data.cpId,
                            images: action.data.images,
                            printer: action.data.printer,
                            site: action.data.site,
                            workflow: action.data.workflow,
                            priority: action.data.priority ?? j.priority,
                            verificationResult: action.data.verificationResult ?? j.verificationResult,
                        }
                        : j;
                })
                : [
                    ...state.cpJobs,
                    {
                        ...action.data,
                        priority: action.data.priority ?? null,
                        verificationResult: action.data.verificationResult ?? null,
                    },
                ];

            return {
                ...state,
                cpJobs: updatedCpJobsAfterUpdate,
            };
        case types.SUBSCRIBE_TO_CP_JOB_CHANNEL_MAPPING_SUCCESS:
            return Object.assign({}, state, {
                cloudJobIds: [...state.cloudJobIds, action.data.jobId],
            });

        case types.LIST_CUSTOMER_HFWFS_SUCCESS:
            return Object.assign({}, state, {
                hfwfs: action.res.data.listCustomerHfWfs.items,
                isFetching: action.res.loading,
            });
        case types.LIST_CUSTOMER_CP_JOB_DETAILS_SUCCESS:
            // console.log('action.payload.jobDetails', action.payload.jobDetails);
            return Object.assign({}, state, {
                jobDetails: {
                    details: action.payload.jobDetails,
                    isFetching: action.payload.isFetching,
                },
            });
        case types.GET_COLOR_CHANNEL_MAPPING_DETAILS:
            return Object.assign({}, state, {
                isFetchingColorChannelMapping: true,
            });
        case types.GET_CUSTOMER_CP_JOB_IDS_SUCCESS:
            return Object.assign({}, state, {
                cloudJobIds: action.res.data.findJobs,
            });
        case types.GET_COLOR_CHANNEL_MAPPING_DETAILS_SUCCESS:
            let channels = [];
            if (action.res.data.getColorChannelMapping) {
                channels = action.res.data.getColorChannelMapping;
            }
            return {
                ...state,
                channelValuesFromState: channels,
                isFetchingColorChannelMapping: false,
                errorColorChannelMapping: null,
            };
        case types.GET_COLOR_CHANNEL_MAPPING_DETAILS_FAILURE:
            return Object.assign({}, state, {
                channelValuesFromState: [],
                isFetchingColorChannelMapping: false,
                errorColorChannelMapping: action.err,
            });
        case types.ADD_ACTION_SUCCESS:
            //  NOTE: why do we do it ? if we do not do anything with that ?
            return { ...state };
        case types.CUSTOMER_CREATE_ORDER_SUCCESS:
            return Object.assign({}, state, {
                uploadInfo: action.res.data.customerCreateOrder,
            });
        case types.DOWNLOAD_JOBDETAILS_FILE_SUCCESS:
            return Object.assign({}, state, {
                fileUrl: action.fileUrl,
            });
        case types.GET_JOB_COOKIES:
            return {
                ...state,
                isFetching: true,
            };
        case types.GET_JOB_COOKIES_SUCCESS:
            // console.log('GET_JOB_COOKIES_SUCCESS action', { action });
            return {
                ...state,
                jobCookies: {
                    ...state.jobCookies,
                    [action.payload.cpId]: action.payload.expiration,
                },
                isFetching: false,
            };
        case types.GET_JOB_COOKIES_FAILURE:
            return {
                ...state,
                isFetching: false,
                graphQLErrors: action.payload.error,
            };
        case types.CLEAR_JOBS_DATA:
            return {
                ...state,
                ...initialState,
            };
        case types.CLEAR_JOB_DETAILS:
            return {
                ...state,
                jobDetails: {
                    details: {
                        images: [],
                        jobControlStrip: undefined,
                    },
                    isFetching: false,
                },
            };
        case types.LIST_CUSTOMER_CP_JOB_DETAILS:
            return {
                ...state,
                jobDetails: {
                    details: {
                        images: [],
                        jobControlStrip: undefined,
                    },
                    isFetching: action.isFetching,
                },
            };
        default:
            return state;
    }
}
